module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container profile"
  }, [_c('two-fa-interno', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show2fa),
      expression: "show2fa"
    }],
    attrs: {
      "origin": 'UPDATE_ACCOUNT'
    },
    on: {
      "sucess2fa": _vm.save
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show2fa),
      expression: "!show2fa"
    }]
  }, [_c('user-data', {
    ref: "userComponent"
  }), _vm._v(" "), _c('address-data', {
    ref: "addressComponent"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-default margin-t10",
    attrs: {
      "id": "btn-confirm-recharge",
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_c('span', {
    staticClass: "text-btn-recharge"
  }, [_vm._v("Salvar dados")]), _vm._v(" "), _c('i', {
    staticClass: "icon-tick align-icon-right-lg"
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-42587548!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/profile/profile.vue
// module id = 2110
// module chunks = 1